import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styles from './MultiSelectDropdown.module.scss';

const MultiSelectDropdown = ({ items, selectedItems, onSelectionChange, placeholder, clearAllText, selectAllText }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);

  const handleToggle = (isOpen) => {
    setShow(isOpen);
  };

  const handleItemToggle = (item) => {
    const isSelected = selectedItems.some(selected => selected.uid === item.uid);
    let newSelection;
    
    if (isSelected) {
      newSelection = selectedItems.filter(selected => selected.uid !== item.uid);
    } else {
      newSelection = [...selectedItems, item];
    }
    
    onSelectionChange(newSelection);
  };

  const handleSelectAll = () => {
    onSelectionChange(items);
  };

  const handleClearAll = () => {
    onSelectionChange([]);
  };

  const getButtonText = () => {
    if (selectedItems.length === 0) {
      return placeholder;
    } else if (selectedItems.length === 1) {
      return selectedItems[0].displayName;
    } else {
      return t('diary.trends.parametersSelected', { count: selectedItems.length });
    }
  };

  return (
    <div ref={dropdownRef} className={styles.multiSelectDropdown}>
      <Dropdown show={show} onToggle={handleToggle}>
        <Dropdown.Toggle variant="success" className={`btn btn-primary ${styles.dropdownToggle}`}>
          {getButtonText()}
        </Dropdown.Toggle>

        <Dropdown.Menu className={styles.dropdownMenu} align="end">
          {/*<div className={styles.dropdownActions}>*/}
          {/*  <button */}
          {/*    className={styles.actionButton}*/}
          {/*    onClick={handleSelectAll}*/}
          {/*    disabled={selectedItems.length === items.length}*/}
          {/*  >*/}
          {/*    {selectAllText}*/}
          {/*  </button>*/}
          {/*  <button */}
          {/*    className={styles.actionButton}*/}
          {/*    onClick={handleClearAll}*/}
          {/*    disabled={selectedItems.length === 0}*/}
          {/*  >*/}
          {/*    {clearAllText}*/}
          {/*  </button>*/}
          {/*</div>*/}
          
          {/*<Dropdown.Divider />*/}
          
          <div className={styles.itemsList}>
            {items.map((item) => (
              <div key={item.uid} className={styles.dropdownItem}>
                <Form.Check
                  type="checkbox"
                  id={`checkbox-${item.uid}`}
                  label={item.displayName}
                  checked={selectedItems.some(selected => selected.uid === item.uid)}
                  onChange={() => handleItemToggle(item)}
                  className={styles.checkbox}
                />
              </div>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MultiSelectDropdown;